import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ContactBaselineModule } from '../contact-baseline/contact-baseline.module';
import { ContactMainReasonsModule } from '../contact-main-reasons/contact-main-reasons.module';
import { ContactMoodtrackerModule } from '../contact-moodtracker/contact-moodtracker.module';
import { ContactSeverityChartModule } from '../contact-severity-chart/contact-severity-chart.module';
import { ContactFollowUpComponent } from './contact-follow-up.component';

@NgModule({
	declarations: [ContactFollowUpComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		ContactMoodtrackerModule,
		ContactBaselineModule,
		ContactMainReasonsModule,
		ContactSeverityChartModule,
	],
	exports: [ContactFollowUpComponent],
	providers: [],
})
export class ContactFollowUpModule {}
